import { render } from "./VUEFrameComponenteGraficoSpostamentiSovrapposti.vue?vue&type=template&id=b6ef42f2"
import script from "./VUEFrameComponenteGraficoSpostamentiSovrapposti.vue?vue&type=script&lang=js"
export * from "./VUEFrameComponenteGraficoSpostamentiSovrapposti.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__